export default "__VITE_ASSET__B6Cy_6kc__"